import React from 'react';
import emailIcon from '../assets/icon/email.png';
import locationIcon from '../assets/icon/location.png';
import {Link} from "react-router";
import {HashLink} from "react-router-hash-link";
const Footer = () => {
    return (
        <footer className="bg-[#002846] text-white py-16 p-5" id={'contact'}>
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                {/* Logo and Tagline */}
                <div className="space-y-2">
                    <h1 className="text-3xl font-bold">Delice</h1>
                    <p className="text-sm text-[#E6E6E6]">EST 1999</p>
                </div>

                {/* Product Section */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">Product</h2>
                    <ul className="space-y-2 text-[#E6E6E6]">
                        <li className="border-b border-gray-400 pb-1">
                            <Link to={'products/dermal-filler'}>
                                Dermal Filler
                            </Link>
                        </li>
                        <li className="border-b border-gray-400 pb-1">
                            <Link to={'/products/skin-booster'}>
                                Skin Booster
                            </Link>
                        </li>
                        <li className="border-b border-gray-400 pb-1">
                            <Link to={'/products/mesotherapy'}>
                                Mesotherapy Cocktails
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* Company Section */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">Company</h2>
                    <ul className="space-y-2 text-[#E6E6E6]">
                        <li className="border-b border-gray-400 pb-1">
                            <HashLink to={'/about#quality'}>
                                About Us
                            </HashLink>
                        </li>
                        <li className="border-b border-gray-400 pb-1">
                            <HashLink to={'/about#why'}>
                                Why Choose Delice?
                            </HashLink>

                        </li>
                        <li className="border-b border-gray-400 pb-1">
                            <HashLink to={'/about#quality'}>
                                Quality and Certifications
                            </HashLink>
                        </li>
                    </ul>
                </div>

                {/* Contact Us Section */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">Contact Us</h2>
                    <ul className="space-y-2">
                        <li className="flex items-center space-x-2">
                            <span className="material-icons">
                                <img src={emailIcon} className={'w-5'} />
                            </span>
                            <a href={'mailto:contact@delice-beauty.com'}>
                                <p>contact@delice-beauty.com</p>
                            </a>

                        </li>
                        <li className="flex items-center space-x-2 space-y-1">
                            <span className="material-icons">
                                <img src={locationIcon} className={'w-5'}/>
                            </span>
                            <p>43 place de Miremont
                                <p>Villeneuve-saint-georges</p>
                                <p>France</p>
                            </p>

                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
